export const statusTranslations = {
  ru: {
    'status.allocation.approvalRequired': 'Требует утверждения',
    'status.allocation.approved': 'Утверждено',
    'status.allocation.cancelled': 'Отменено',
    'status.allocation.confirmed': 'Готово к подтверждению',
    'status.allocation.draft': 'Черновик',
    'status.allocation.failed': 'Ошибка',
    'status.allocation.needsReview': 'Требует проверки',
    'status.allocation.posted': 'Проведено',
    'status.allocation.postingQueued': 'В очереди проведения',
    'status.allocation.preview': 'Предпросмотр',
    'status.allocation.reconciled': 'Сверено',
    'status.allocation.suggested': 'Предложено системой',
    'status.allocationWarning.currency_mismatch': 'Несовпадение валюты',
    'status.allocationWarning.document_already_paid': 'Документ уже оплачен',
    'status.allocationWarning.document_processing_state_unknown': 'Статус проведения неизвестен',
    'status.allocationWarning.document_not_processed': 'Накладная не проведена',
    'status.allocationWarning.document_deleted': 'Накладная удалена',
    'status.allocationWarning.document_not_payable': 'Накладная недоступна для оплаты',
    'status.allocationWarning.low_confidence': 'Низкая уверенность',
    'status.allocationWarning.manual_outlet_review_required': 'Нужна ручная проверка Outlet',
    'status.allocationWarning.negative_amount': 'Отрицательная сумма',
    'status.allocationWarning.no_lines': 'Нет строк распределения',
    'status.allocationWarning.outlet_ambiguous': 'Неоднозначный Outlet',
    'status.allocationWarning.outlet_unresolved': 'Outlet не определён',
    'status.allocationWarning.overpayment': 'Переплата',
    'status.allocationWarning.partial_payment': 'Частичная оплата',
    'status.allocationWarning.payment_not_fully_distributed': 'Платёж распределён не полностью',
    'status.allocationWarning.supplier_advance_transport_unavailable': 'Запись аванса в Syrve недоступна',
    'status.allocationWarning.stale_document': 'Устаревший документ',
    'status.allocationWarning.underpayment': 'Недоплата',
    'status.business.account_required': 'Не выбран счёт для проведения',
    'status.business.already_posted': 'Проведение уже выполнено',
    'status.business.approval_required': 'Проведение требует утверждения оператором',
    'status.business.auth_failed': 'Syrve отклонил учетные данные',
    'status.business.backoffice_verification_recorded': 'Ручная проверка BackOffice записана.',
    'status.business.backoffice_verification_required': 'Требуется ручная проверка в Syrve BackOffice.',
    'status.business.balance_mismatch': 'Есть расхождение по балансу.',
    'status.business.bank_import_balance_review_required': 'Проведение заблокировано в Pay: баланс выписки не сходится. Откройте импорт → «Качество» → подтвердите проверку баланса.',
    'status.business.bank_statement_upload_disabled': 'Загрузка банковских выписок отключена для организации.',
    'status.business.bridge_missing': 'Не создана связь с Syrve',
    'status.business.cash_flow_article_required': 'Не выбрана статья ДДС',
    'status.business.connection_not_connected': 'Подключение Syrve не в статусе connected',
    'status.business.connection_not_connected_for_write': 'Подключение Syrve не готово к безопасному проведению оплаты',
    'status.business.counterparty_not_extracted': 'Контрагент не распознан.',
    'status.business.counterparty_not_found': 'Не найден контрагент. Выберите контрагента вручную или создайте правило сопоставления.',
    'status.business.credentials_missing': 'Не найден secret с учетными данными',
    'status.business.document_processing_state_unknown': 'Статус проведения накладной неизвестен. Обновите документы Syrve.',
    'status.business.document_not_processed': 'Накладная не проведена в Syrve и не может быть оплачена.',
    'status.business.document_deleted': 'Накладная удалена в Syrve и не может быть оплачена.',
    'status.business.document_not_payable': 'Накладная больше недоступна для оплаты.',
    'status.business.payment_not_fully_distributed': 'Часть банковского платежа не распределена. Вся сумма должна быть направлена на задолженность или аванс.',
    'status.business.supplier_advance_transport_unavailable': 'Создание и readback аванса поставщику в Syrve пока не подтверждены. Проведение заблокировано.',
    'status.business.write_outcome_unknown': 'Результат внешней записи неизвестен. Слепой повтор запрещён.',
    'status.business.write_outcome_unknown_readback_required': 'Перед повтором внешней записи требуется readback.',
    'status.business.document_sync_disabled': 'Синхронизация документов отключена настройками',
    'status.business.duplicate_bank_reference': 'Похожий платеж уже импортирован. Проверьте, не является ли это дублем.',
    'status.business.duplicate_payment_suspected': 'Возможен дубль платежа — требуется ручная проверка.',
    'status.business.duplicate_transaction_candidate': 'Найдены возможные дубли транзакций.',
    'status.business.endpoint_not_verified': 'Интеграция не готова для этой операции. Обратитесь к администратору.',
    'status.business.idempotency_conflict': 'Конфликт idempotency: тот же ключ с другим request hash',
    'status.business.idempotency_key_missing': 'Отсутствует idempotency key',
    'status.business.iiko_forbidden': 'У учетной записи нет прав на этот endpoint',
    'status.business.iiko_rest_session_auth_failed': 'Syrve отклонил учетные данные при REST-аутентификации',
    'status.business.iiko_runtime_disabled': 'Runtime-вызовы Syrve отключены',
    'status.business.iiko_unavailable': 'Сервер Syrve недоступен',
    'status.business.import_needs_review': 'Импорт требует проверки.',
    'status.business.import_success_with_warnings': 'Импорт завершён с предупреждениями.',
    'status.business.invalid_base_url': 'Некорректный адрес Syrve',
    'status.business.location_not_found': 'Точка не найдена.',
    'status.business.location_scope_required': 'Укажите точку для операции.',
    'status.business.low_confidence_match': 'Система не уверена в совпадении. Проверьте контрагента перед оплатой.',
    'status.business.low_detection_confidence': 'Низкая уверенность распознавания — проверьте импорт вручную.',
    'status.business.low_parse_confidence': 'Низкое качество парсинга — проверьте импорт вручную.',
    'status.business.manual_review_required': 'Требуется ручная проверка в Syrve BackOffice.',
    'status.business.optimistic_after_not_confirmed': 'Ожидаемое состояние не подтверждено live readback.',
    'status.business.organization_not_found': 'Организация не найдена.',
    'status.business.organization_scope_required': 'Укажите организацию для операции.',
    'status.business.overpaid_after_write': 'Документ выглядит переплаченным — повторное проведение заблокировано.',
    'status.business.pass_readonly_empty': 'Подключение работает, но документы не найдены за выбранный период',
    'status.business.password_mode_mismatch': 'Возможно, выбран неверный режим секрета: пароль или хэш пароля',
    'status.business.payment_anomaly_open': 'Открыта критическая аномалия — повторное проведение заблокировано.',
    'status.business.payment_post_failed': 'Платеж не отправлен в Syrve. Откройте детали ошибки и повторите после исправления.',
    'status.business.payment_write_disabled': 'Проведение оплат отключено настройками',
    'status.business.permission_denied_for_scope': 'Нет доступа к этой организации или точке.',
    'status.business.posting_rule_multi_line_unsupported': 'Многострочное распределение пока не поддерживается для автоматического проведения.',
    'status.business.posting_type_document_type_mismatch': 'Тип проведения не соответствует типу документа',
    'status.business.production_write_not_available': 'Production write пока недоступен.',
    'status.business.production_writes_disabled': 'Проведение оплат в боевом контуре запрещено',
    'status.business.quota_max_locations_reached': 'Достигнут лимит точек для организации.',
    'status.business.quota_max_rms_connections_reached': 'Достигнут лимит RMS/Syrve подключений.',
    'status.business.quota_max_users_reached': 'Достигнут лимит пользователей для организации.',
    'status.business.readback_document_unavailable': 'Документ не удалось перечитать после проведения',
    'status.business.readback_pending': 'Платёж проведён, но сверка ещё не подтверждена.',
    'status.business.readback_sources_disagree': 'Источники readback не согласны.',
    'status.business.reconciliation_amount_mismatch': 'Сумма задолженности после проведения не совпадает с ожидаемой.',
    'status.business.resolved_manually': 'Аномалия закрыта вручную.',
    'status.business.rows_skipped': 'Часть строк была пропущена.',
    'status.business.runtime_calls_disabled': 'Live-запросы к Syrve отключены настройками',
    'status.business.session_endpoint_not_found': 'Endpoint авторизации не найден. Проверьте версию/URL Syrve',
    'status.business.supported_banks_unavailable': 'Не удалось загрузить список поддерживаемых банков.',
    'status.business.syrve_posting_rule_conflict': 'Найдено несколько подходящих правил проведения. Уточните правило вручную.',
    'status.business.syrve_posting_rule_no_match': 'Не найдено правило проведения для документа. Настройте счёт и статью ДДС.',
    'status.business.syrve_posting_rule_unsupported': 'Текущая раскладка не поддерживается для автоматического проведения.',
    'status.business.test_payment_write_disabled_for_organization': 'Тестовое проведение платежей отключено для организации.',
    'status.business.test_writes_disabled': 'Проведение оплат в test-контуре отключено настройками',
    'status.business.timeout': 'Syrve не ответил вовремя',
    'status.business.unpaid_increased_after_write': 'После проведения задолженность увеличилась — требуется проверка в Syrve BackOffice.',
    'status.business.unsupported_bank_format': 'Формат банка пока не поддерживается.',
    'status.business.write_contract_not_verified': 'Контракт payment write не верифицирован',
    'status.business.write_method_forbidden': 'Метод проведения запрещён текущими настройками Syrve',
    'status.business.write_method_not_supported_for_document_type': 'Тип документа не поддержан текущим методом проведения',
    'status.business.write_not_implemented': 'Проведение оплат еще не подключено к live write API',
    'status.business.write_posted_but_not_visible_in_readback': 'Платёж проведён, но сверка не подтверждена.',
    'status.business.write_preflight_required': 'Перед проведением нужна method-specific preflight проверка',
    'status.business.write_response_transaction_type_mismatch': 'Тип транзакции в ответе Syrve не совпал с ожидаемым.',
    'status.business.wrong_account_access_denied': 'Доступ к счёту для проведения отклонён Syrve.',
    'status.candidateWarning.manual_outlet_review_required': 'Выберите Outlet вручную',
    'status.candidateWarning.no_counterparty_match': 'Контрагент не совпал',
    'status.candidateWarning.outlet_ambiguous': 'Несколько Outlet',
    'status.candidateWarning.possible_duplicate': 'Возможный дубль',
    'status.duplicate.matchType.medium': 'Похоже на дубль',
    'status.duplicate.matchType.strong': 'Высокая вероятность дубля',
    'status.duplicate.matchType.weak': 'Нужно проверить',
    'status.duplicate.signal.accountNumber': 'Счёт',
    'status.duplicate.signal.amount': 'Сумма',
    'status.duplicate.signal.bankReference': 'Банковская ссылка',
    'status.duplicate.signal.counterparty': 'Контрагент',
    'status.duplicate.signal.currency': 'Валюта',
    'status.duplicate.signal.customerReference': 'Клиентская ссылка',
    'status.duplicate.signal.description': 'Описание',
    'status.duplicate.signal.direction': 'Направление',
    'status.duplicate.signal.sourceBank': 'Банк',
    'status.duplicate.signal.transactionDate': 'Дата',
    'status.duplicate.status.candidate': 'Ожидает решения',
    'status.duplicate.status.confirmed': 'Подтверждённый дубль',
    'status.duplicate.status.dismissed': 'Не дубль',
    'status.import.accepted': 'Принят в обработку',
    'status.import.failed': 'Ошибка импорта — проверьте формат файла',
    'status.import.parsed': 'Распознано — можно сопоставлять контрагентов',
    'status.import.processing': 'Обработка файла…',
    'status.manualCorrection.applied': 'Применена',
    'status.manualCorrection.cancelled': 'Отменена',
    'status.manualCorrection.draft': 'Черновик',
    'status.manualCorrectionType.bankTransactionMetadata': 'Метаданные транзакции',
    'status.manualCorrectionType.counterpartyMatch': 'Сопоставление контрагента',
    'status.manualCorrectionType.importQualityOverride': 'Override качества импорта',
    'status.manualCorrectionType.other': 'Другое',
    'status.manualCorrectionType.paymentAllocationNote': 'Заметка к распределению',
    'status.match.autoMatched': 'Авто-сопоставлено',
    'status.match.lowConfidence': 'Низкая уверенность',
    'status.match.manualMatched': 'Сопоставлено вручную',
    'status.match.unmatched': 'Не найден контрагент',
    'status.match.excluded': 'Исключено из сопоставления',
    'status.matchType.candidate': 'Кандидат',
    'status.matchType.manual': 'Вручную',
    'status.matchType.noMatch': 'Без совпадения',
    'status.matchType.normalized': 'Нормализация',
    'status.matchType.rule': 'Правило',
    'status.quality.parseFailed': 'Ошибка парсинга',
    'status.quality.success': 'Успешно',
    'status.syrvePayment.cancelled': 'Отменено',
    'status.syrvePayment.overpaid': 'Переплата',
    'status.syrvePayment.paid': 'Оплачено',
    'status.syrvePayment.partiallyPaid': 'Частично оплачено',
    'status.syrvePayment.stale': 'Не найдено при последней синхронизации',
    'status.syrvePayment.unpaid': 'Не оплачено',
    'status.syrvePosting.approvalRequired': 'Требует утверждения',
    'status.syrvePosting.approved': 'Утверждено к проведению',
    'status.syrvePosting.cancelled': 'Отменено',
    'status.syrvePosting.cancelledByHardDelete': 'Отменено удалением Pay-данных',
    'status.syrvePosting.draft': 'Черновик проведения',
    'status.syrvePosting.failed': 'Ошибка',
    'status.syrvePosting.paymentWriteDisabled': 'Проведение оплат отключено настройками',
    'status.syrvePosting.posted': 'Проведено, ожидает сверки',
    'status.syrvePosting.posting': 'Проводится worker-ом',
    'status.syrvePosting.queued': 'В очереди',
    'status.syrvePosting.readbackPending': 'Ожидает проверки после проведения',
    'status.syrvePosting.writeOutcomeUnknown': 'Результат записи неизвестен — требуется readback',
    'status.syrvePosting.reconciled': 'Сверено',
    'status.syrvePosting.retryScheduled': 'Повтор будет выполнен автоматически',
    'status.syrvePosting.skipped': 'Пропущено',
    'status.upload.accepted.helper': 'Файл загружен и поставлен в обработку. Откройте импорт, чтобы следить за результатом.',
    'status.upload.accepted.label': 'Файл принят',
    'status.upload.duplicate.helper': 'Этот файл уже был импортирован в этой организации. Откройте существующий импорт.',
    'status.upload.duplicate.label': 'Файл уже загружен',
    'status.upload.failed.helper': 'Файл не удалось обработать. Проверьте формат и попробуйте снова.',
    'status.upload.failed.label': 'Ошибка импорта',
    'status.upload.generic.helper': 'Откройте импорт, чтобы посмотреть детали.',
    'status.upload.generic.label': 'Статус импорта',
    'status.upload.generic.labelWithStatus': 'Статус импорта: {status}',
    'status.upload.parsed.helper': 'Транзакции распознаны. Проверьте качество импорта и сопоставление контрагентов.',
    'status.upload.parsed.label': 'Импорт распознан',
  },
  en: {
    'status.allocation.approvalRequired': 'Approval required',
    'status.allocation.approved': 'Approved',
    'status.allocation.cancelled': 'Cancelled',
    'status.allocation.confirmed': 'Ready to confirm',
    'status.allocation.draft': 'Draft',
    'status.allocation.failed': 'Error',
    'status.allocation.needsReview': 'Needs review',
    'status.allocation.posted': 'Posted',
    'status.allocation.postingQueued': 'Posting queued',
    'status.allocation.preview': 'Preview',
    'status.allocation.reconciled': 'Reconciled',
    'status.allocation.suggested': 'Suggested by system',
    'status.allocationWarning.currency_mismatch': 'Currency mismatch',
    'status.allocationWarning.document_already_paid': 'Document already paid',
    'status.allocationWarning.document_processing_state_unknown': 'Processing state unknown',
    'status.allocationWarning.document_not_processed': 'Document not processed',
    'status.allocationWarning.document_deleted': 'Document deleted',
    'status.allocationWarning.document_not_payable': 'Document is not payable',
    'status.allocationWarning.low_confidence': 'Low confidence',
    'status.allocationWarning.manual_outlet_review_required': 'Manual outlet review required',
    'status.allocationWarning.negative_amount': 'Negative amount',
    'status.allocationWarning.no_lines': 'No allocation lines',
    'status.allocationWarning.outlet_ambiguous': 'Ambiguous outlet',
    'status.allocationWarning.outlet_unresolved': 'Outlet unresolved',
    'status.allocationWarning.overpayment': 'Overpayment',
    'status.allocationWarning.partial_payment': 'Partial payment',
    'status.allocationWarning.payment_not_fully_distributed': 'Payment is not fully distributed',
    'status.allocationWarning.supplier_advance_transport_unavailable': 'Supplier advance transport unavailable',
    'status.allocationWarning.stale_document': 'Stale document',
    'status.allocationWarning.underpayment': 'Underpayment',
    'status.business.account_required': 'Posting account not selected',
    'status.business.already_posted': 'Already posted',
    'status.business.approval_required': 'Posting requires operator approval',
    'status.business.auth_failed': 'Syrve rejected credentials',
    'status.business.backoffice_verification_recorded': 'BackOffice manual verification recorded.',
    'status.business.backoffice_verification_required': 'Manual Syrve BackOffice verification required.',
    'status.business.balance_mismatch': 'Balance mismatch detected.',
    'status.business.bank_import_balance_review_required': 'Posting blocked in Pay: statement balance does not match. Open the import → Quality → confirm balance review.',
    'status.business.bank_statement_upload_disabled': 'Bank statement upload disabled for organization.',
    'status.business.bridge_missing': 'Syrve bridge not created',
    'status.business.cash_flow_article_required': 'Cash flow category not selected',
    'status.business.connection_not_connected': 'Syrve connection not in connected status',
    'status.business.connection_not_connected_for_write': 'Syrve connection not ready for safe payment posting',
    'status.business.counterparty_not_extracted': 'Counterparty not recognized.',
    'status.business.counterparty_not_found': 'Counterparty not found. Select manually or create a matching rule.',
    'status.business.credentials_missing': 'Credentials secret not found',
    'status.business.document_processing_state_unknown': 'Document processing state is unknown. Refresh Syrve documents.',
    'status.business.document_not_processed': 'Document is not processed in Syrve and cannot be paid.',
    'status.business.document_deleted': 'Document is deleted in Syrve and cannot be paid.',
    'status.business.document_not_payable': 'Document not payable or not linked to snapshot',
    'status.business.payment_not_fully_distributed': 'Part of the bank payment is unallocated. The full amount must settle debt or create a supplier advance.',
    'status.business.supplier_advance_transport_unavailable': 'Supplier advance write and readback are not verified in Syrve. Posting is blocked.',
    'status.business.write_outcome_unknown': 'External write outcome is unknown. Blind retry is blocked.',
    'status.business.write_outcome_unknown_readback_required': 'Readback is required before retrying the external write.',
    'status.business.document_sync_disabled': 'Document sync disabled by settings',
    'status.business.duplicate_bank_reference': 'Similar payment already imported. Check if this is a duplicate.',
    'status.business.duplicate_payment_suspected': 'Possible duplicate payment — manual review required.',
    'status.business.duplicate_transaction_candidate': 'Possible duplicate transactions found.',
    'status.business.endpoint_not_verified': 'Integration not ready for this operation. Contact administrator.',
    'status.business.idempotency_conflict': 'Idempotency conflict: same key with different request hash',
    'status.business.idempotency_key_missing': 'Idempotency key missing',
    'status.business.iiko_forbidden': 'Account lacks permission for this endpoint',
    'status.business.iiko_rest_session_auth_failed': 'Syrve rejected credentials during REST authentication',
    'status.business.iiko_runtime_disabled': 'Syrve runtime calls disabled',
    'status.business.iiko_unavailable': 'Syrve server unavailable',
    'status.business.import_needs_review': 'Import needs review.',
    'status.business.import_success_with_warnings': 'Import completed with warnings.',
    'status.business.invalid_base_url': 'Invalid Syrve URL',
    'status.business.location_not_found': 'Location not found.',
    'status.business.location_scope_required': 'Specify location for operation.',
    'status.business.low_confidence_match': 'Low confidence match. Verify counterparty before payment.',
    'status.business.low_detection_confidence': 'Low detection confidence — review import manually.',
    'status.business.low_parse_confidence': 'Low parse quality — review import manually.',
    'status.business.manual_review_required': 'Manual review required in Syrve BackOffice.',
    'status.business.optimistic_after_not_confirmed': 'Expected state not confirmed by live readback.',
    'status.business.organization_not_found': 'Organization not found.',
    'status.business.organization_scope_required': 'Specify organization for operation.',
    'status.business.overpaid_after_write': 'Document appears overpaid — reposting blocked.',
    'status.business.pass_readonly_empty': 'Connection works but no documents found for selected period',
    'status.business.password_mode_mismatch': 'Wrong secret mode: password or password hash',
    'status.business.payment_anomaly_open': 'Critical anomaly open — reposting blocked.',
    'status.business.payment_post_failed': 'Payment not sent to Syrve. Open error details and retry after fix.',
    'status.business.payment_write_disabled': 'Payment posting disabled by settings',
    'status.business.permission_denied_for_scope': 'No access to this organization or location.',
    'status.business.posting_rule_multi_line_unsupported': 'Multi-line allocation not yet supported for automatic posting.',
    'status.business.posting_type_document_type_mismatch': 'Posting type does not match document type',
    'status.business.production_write_not_available': 'Production write not yet available.',
    'status.business.production_writes_disabled': 'Production payment posting forbidden',
    'status.business.quota_max_locations_reached': 'Location limit reached for organization.',
    'status.business.quota_max_rms_connections_reached': 'RMS/Syrve connection limit reached.',
    'status.business.quota_max_users_reached': 'User limit reached for organization.',
    'status.business.readback_document_unavailable': 'Could not re-read document after posting',
    'status.business.readback_pending': 'Payment posted but reconciliation not yet confirmed.',
    'status.business.readback_sources_disagree': 'Readback sources disagree.',
    'status.business.reconciliation_amount_mismatch': 'Debt amount after posting does not match expected.',
    'status.business.resolved_manually': 'Anomaly closed manually.',
    'status.business.rows_skipped': 'Some rows were skipped.',
    'status.business.runtime_calls_disabled': 'Live Syrve calls disabled by settings',
    'status.business.session_endpoint_not_found': 'Auth endpoint not found. Check Syrve version/URL',
    'status.business.supported_banks_unavailable': 'Could not load supported banks list.',
    'status.business.syrve_posting_rule_conflict': 'Multiple posting rules match. Refine rule manually.',
    'status.business.syrve_posting_rule_no_match': 'No posting rule found for document. Configure account and cash flow category.',
    'status.business.syrve_posting_rule_unsupported': 'Current layout not supported for automatic posting.',
    'status.business.test_payment_write_disabled_for_organization': 'Test payment posting disabled for organization.',
    'status.business.test_writes_disabled': 'Test payment posting disabled by settings',
    'status.business.timeout': 'Syrve did not respond in time',
    'status.business.unpaid_increased_after_write': 'Debt increased after posting — verify in Syrve BackOffice.',
    'status.business.unsupported_bank_format': 'Bank format not yet supported.',
    'status.business.write_contract_not_verified': 'Payment write contract not verified',
    'status.business.write_method_forbidden': 'Posting method forbidden by current Syrve settings',
    'status.business.write_method_not_supported_for_document_type': 'Document type not supported by current posting method',
    'status.business.write_not_implemented': 'Payment posting not yet connected to live write API',
    'status.business.write_posted_but_not_visible_in_readback': 'Payment posted but reconciliation not confirmed.',
    'status.business.write_preflight_required': 'Method-specific preflight check required before posting',
    'status.business.write_response_transaction_type_mismatch': 'Transaction type in Syrve response did not match expected.',
    'status.business.wrong_account_access_denied': 'Posting account access denied by Syrve.',
    'status.candidateWarning.manual_outlet_review_required': 'Select outlet manually',
    'status.candidateWarning.no_counterparty_match': 'Counterparty mismatch',
    'status.candidateWarning.outlet_ambiguous': 'Multiple outlets',
    'status.candidateWarning.possible_duplicate': 'Possible duplicate',
    'status.duplicate.matchType.medium': 'Likely duplicate',
    'status.duplicate.matchType.strong': 'High duplicate probability',
    'status.duplicate.matchType.weak': 'Needs review',
    'status.duplicate.signal.accountNumber': 'Account',
    'status.duplicate.signal.amount': 'Amount',
    'status.duplicate.signal.bankReference': 'Bank reference',
    'status.duplicate.signal.counterparty': 'Counterparty',
    'status.duplicate.signal.currency': 'Currency',
    'status.duplicate.signal.customerReference': 'Customer reference',
    'status.duplicate.signal.description': 'Description',
    'status.duplicate.signal.direction': 'Direction',
    'status.duplicate.signal.sourceBank': 'Bank',
    'status.duplicate.signal.transactionDate': 'Date',
    'status.duplicate.status.candidate': 'Pending decision',
    'status.duplicate.status.confirmed': 'Confirmed duplicate',
    'status.duplicate.status.dismissed': 'Not a duplicate',
    'status.import.accepted': 'Accepted for processing',
    'status.import.failed': 'Import failed — check file format',
    'status.import.parsed': 'Parsed — ready for counterparty matching',
    'status.import.processing': 'Processing file…',
    'status.manualCorrection.applied': 'Applied',
    'status.manualCorrection.cancelled': 'Cancelled',
    'status.manualCorrection.draft': 'Draft',
    'status.manualCorrectionType.bankTransactionMetadata': 'Transaction metadata',
    'status.manualCorrectionType.counterpartyMatch': 'Counterparty match',
    'status.manualCorrectionType.importQualityOverride': 'Import quality override',
    'status.manualCorrectionType.other': 'Other',
    'status.manualCorrectionType.paymentAllocationNote': 'Allocation note',
    'status.match.autoMatched': 'Auto-matched',
    'status.match.lowConfidence': 'Low confidence',
    'status.match.manualMatched': 'Manually matched',
    'status.match.unmatched': 'Counterparty not found',
    'status.match.excluded': 'Excluded from matching',
    'status.matchType.candidate': 'Candidate',
    'status.matchType.manual': 'Manual',
    'status.matchType.noMatch': 'No match',
    'status.matchType.normalized': 'Normalization',
    'status.matchType.rule': 'Rule',
    'status.quality.parseFailed': 'Parse error',
    'status.quality.success': 'Success',
    'status.syrvePayment.cancelled': 'Cancelled',
    'status.syrvePayment.overpaid': 'Overpaid',
    'status.syrvePayment.paid': 'Paid',
    'status.syrvePayment.partiallyPaid': 'Partially paid',
    'status.syrvePayment.stale': 'Not found in last sync',
    'status.syrvePayment.unpaid': 'Unpaid',
    'status.syrvePosting.approvalRequired': 'Approval required',
    'status.syrvePosting.approved': 'Approved for posting',
    'status.syrvePosting.cancelled': 'Cancelled',
    'status.syrvePosting.cancelledByHardDelete': 'Cancelled by Pay data deletion',
    'status.syrvePosting.draft': 'Posting draft',
    'status.syrvePosting.failed': 'Error',
    'status.syrvePosting.paymentWriteDisabled': 'Payment posting disabled by settings',
    'status.syrvePosting.posted': 'Posted, awaiting reconciliation',
    'status.syrvePosting.posting': 'Posting in progress',
    'status.syrvePosting.queued': 'Queued',
    'status.syrvePosting.readbackPending': 'Awaiting post-posting check',
    'status.syrvePosting.writeOutcomeUnknown': 'Write outcome unknown — readback required',
    'status.syrvePosting.reconciled': 'Reconciled',
    'status.syrvePosting.retryScheduled': 'Retry scheduled automatically',
    'status.syrvePosting.skipped': 'Skipped',
    'status.upload.accepted.helper': 'File uploaded and queued. Open the import to track progress.',
    'status.upload.accepted.label': 'File accepted',
    'status.upload.duplicate.helper': 'This file was already imported in this organization. Open the existing import.',
    'status.upload.duplicate.label': 'File already uploaded',
    'status.upload.failed.helper': 'Could not process the file. Check format and try again.',
    'status.upload.failed.label': 'Import error',
    'status.upload.generic.helper': 'Open the import to view details.',
    'status.upload.generic.label': 'Import status',
    'status.upload.generic.labelWithStatus': 'Import status: {status}',
    'status.upload.parsed.helper': 'Transactions parsed. Review import quality and counterparty matching.',
    'status.upload.parsed.label': 'Import parsed',
  },
  id: {
    'status.allocation.approvalRequired': 'Perlu persetujuan',
    'status.allocation.approved': 'Disetujui',
    'status.allocation.cancelled': 'Dibatalkan',
    'status.allocation.confirmed': 'Siap dikonfirmasi',
    'status.allocation.draft': 'Draf',
    'status.allocation.failed': 'Kesalahan',
    'status.allocation.needsReview': 'Perlu diperiksa',
    'status.allocation.posted': 'Dicatat',
    'status.allocation.postingQueued': 'Pencatatan dalam antrean',
    'status.allocation.preview': 'Pratinjau',
    'status.allocation.reconciled': 'Direkonsiliasi',
    'status.allocation.suggested': 'Disarankan sistem',
    'status.allocationWarning.currency_mismatch': 'Mata uang tidak cocok',
    'status.allocationWarning.document_already_paid': 'Dokumen sudah dibayar',
    'status.allocationWarning.document_processing_state_unknown': 'Status pemrosesan tidak diketahui',
    'status.allocationWarning.document_not_processed': 'Dokumen belum diproses',
    'status.allocationWarning.document_deleted': 'Dokumen dihapus',
    'status.allocationWarning.document_not_payable': 'Dokumen tidak dapat dibayar',
    'status.allocationWarning.low_confidence': 'Keyakinan rendah',
    'status.allocationWarning.manual_outlet_review_required': 'Perlu pemeriksaan outlet manual',
    'status.allocationWarning.negative_amount': 'Jumlah negatif',
    'status.allocationWarning.no_lines': 'Tidak ada baris alokasi',
    'status.allocationWarning.outlet_ambiguous': 'Outlet ambigu',
    'status.allocationWarning.outlet_unresolved': 'Outlet belum ditentukan',
    'status.allocationWarning.overpayment': 'Kelebihan bayar',
    'status.allocationWarning.partial_payment': 'Pembayaran sebagian',
    'status.allocationWarning.payment_not_fully_distributed': 'Pembayaran belum dialokasikan sepenuhnya',
    'status.allocationWarning.supplier_advance_transport_unavailable': 'Transport uang muka pemasok tidak tersedia',
    'status.allocationWarning.stale_document': 'Dokumen usang',
    'status.allocationWarning.underpayment': 'Kurang bayar',
    'status.business.account_required': 'Posting account not selected',
    'status.business.already_posted': 'Already posted',
    'status.business.approval_required': 'Posting requires operator approval',
    'status.business.auth_failed': 'Syrve rejected credentials',
    'status.business.backoffice_verification_recorded': 'BackOffice manual verification recorded.',
    'status.business.backoffice_verification_required': 'Manual Syrve BackOffice verification required.',
    'status.business.balance_mismatch': 'Balance mismatch detected.',
    'status.business.bank_import_balance_review_required': 'Posting blocked in Pay: statement balance does not match. Open the import → Quality → confirm balance review.',
    'status.business.bank_statement_upload_disabled': 'Bank statement upload disabled for organization.',
    'status.business.bridge_missing': 'Syrve bridge not created',
    'status.business.cash_flow_article_required': 'Cash flow category not selected',
    'status.business.connection_not_connected': 'Syrve connection not in connected status',
    'status.business.connection_not_connected_for_write': 'Syrve connection not ready for safe payment posting',
    'status.business.counterparty_not_extracted': 'Counterparty not recognized.',
    'status.business.counterparty_not_found': 'Counterparty not found. Select manually or create a matching rule.',
    'status.business.credentials_missing': 'Credentials secret not found',
    'status.business.document_processing_state_unknown': 'Status pemrosesan dokumen tidak diketahui. Segarkan dokumen Syrve.',
    'status.business.document_not_processed': 'Dokumen belum diproses di Syrve dan tidak dapat dibayar.',
    'status.business.document_deleted': 'Dokumen dihapus di Syrve dan tidak dapat dibayar.',
    'status.business.document_not_payable': 'Document not payable or not linked to snapshot',
    'status.business.payment_not_fully_distributed': 'Sebagian pembayaran bank belum dialokasikan. Jumlah penuh harus melunasi utang atau menjadi uang muka pemasok.',
    'status.business.supplier_advance_transport_unavailable': 'Penulisan dan readback uang muka pemasok di Syrve belum diverifikasi. Posting diblokir.',
    'status.business.write_outcome_unknown': 'Hasil penulisan eksternal tidak diketahui. Pengulangan buta diblokir.',
    'status.business.write_outcome_unknown_readback_required': 'Readback diperlukan sebelum mengulangi penulisan eksternal.',
    'status.business.document_sync_disabled': 'Document sync disabled by settings',
    'status.business.duplicate_bank_reference': 'Similar payment already imported. Check if this is a duplicate.',
    'status.business.duplicate_payment_suspected': 'Possible duplicate payment — manual review required.',
    'status.business.duplicate_transaction_candidate': 'Possible duplicate transactions found.',
    'status.business.endpoint_not_verified': 'Integration not ready for this operation. Contact administrator.',
    'status.business.idempotency_conflict': 'Idempotency conflict: same key with different request hash',
    'status.business.idempotency_key_missing': 'Idempotency key missing',
    'status.business.iiko_forbidden': 'Account lacks permission for this endpoint',
    'status.business.iiko_rest_session_auth_failed': 'Syrve rejected credentials during REST authentication',
    'status.business.iiko_runtime_disabled': 'Syrve runtime calls disabled',
    'status.business.iiko_unavailable': 'Syrve server unavailable',
    'status.business.import_needs_review': 'Import needs review.',
    'status.business.import_success_with_warnings': 'Import completed with warnings.',
    'status.business.invalid_base_url': 'Invalid Syrve URL',
    'status.business.location_not_found': 'Location not found.',
    'status.business.location_scope_required': 'Specify location for operation.',
    'status.business.low_confidence_match': 'Low confidence match. Verify counterparty before payment.',
    'status.business.low_detection_confidence': 'Low detection confidence — review import manually.',
    'status.business.low_parse_confidence': 'Low parse quality — review import manually.',
    'status.business.manual_review_required': 'Manual review required in Syrve BackOffice.',
    'status.business.optimistic_after_not_confirmed': 'Expected state not confirmed by live readback.',
    'status.business.organization_not_found': 'Organization not found.',
    'status.business.organization_scope_required': 'Specify organization for operation.',
    'status.business.overpaid_after_write': 'Document appears overpaid — reposting blocked.',
    'status.business.pass_readonly_empty': 'Connection works but no documents found for selected period',
    'status.business.password_mode_mismatch': 'Wrong secret mode: password or password hash',
    'status.business.payment_anomaly_open': 'Critical anomaly open — reposting blocked.',
    'status.business.payment_post_failed': 'Payment not sent to Syrve. Open error details and retry after fix.',
    'status.business.payment_write_disabled': 'Payment posting disabled by settings',
    'status.business.permission_denied_for_scope': 'No access to this organization or location.',
    'status.business.posting_rule_multi_line_unsupported': 'Multi-line allocation not yet supported for automatic posting.',
    'status.business.posting_type_document_type_mismatch': 'Posting type does not match document type',
    'status.business.production_write_not_available': 'Production write not yet available.',
    'status.business.production_writes_disabled': 'Production payment posting forbidden',
    'status.business.quota_max_locations_reached': 'Location limit reached for organization.',
    'status.business.quota_max_rms_connections_reached': 'RMS/Syrve connection limit reached.',
    'status.business.quota_max_users_reached': 'User limit reached for organization.',
    'status.business.readback_document_unavailable': 'Could not re-read document after posting',
    'status.business.readback_pending': 'Payment posted but reconciliation not yet confirmed.',
    'status.business.readback_sources_disagree': 'Readback sources disagree.',
    'status.business.reconciliation_amount_mismatch': 'Debt amount after posting does not match expected.',
    'status.business.resolved_manually': 'Anomaly closed manually.',
    'status.business.rows_skipped': 'Some rows were skipped.',
    'status.business.runtime_calls_disabled': 'Live Syrve calls disabled by settings',
    'status.business.session_endpoint_not_found': 'Auth endpoint not found. Check Syrve version/URL',
    'status.business.supported_banks_unavailable': 'Could not load supported banks list.',
    'status.business.syrve_posting_rule_conflict': 'Multiple posting rules match. Refine rule manually.',
    'status.business.syrve_posting_rule_no_match': 'No posting rule found for document. Configure account and cash flow category.',
    'status.business.syrve_posting_rule_unsupported': 'Current layout not supported for automatic posting.',
    'status.business.test_payment_write_disabled_for_organization': 'Test payment posting disabled for organization.',
    'status.business.test_writes_disabled': 'Test payment posting disabled by settings',
    'status.business.timeout': 'Syrve did not respond in time',
    'status.business.unpaid_increased_after_write': 'Debt increased after posting — verify in Syrve BackOffice.',
    'status.business.unsupported_bank_format': 'Bank format not yet supported.',
    'status.business.write_contract_not_verified': 'Payment write contract not verified',
    'status.business.write_method_forbidden': 'Posting method forbidden by current Syrve settings',
    'status.business.write_method_not_supported_for_document_type': 'Document type not supported by current posting method',
    'status.business.write_not_implemented': 'Payment posting not yet connected to live write API',
    'status.business.write_posted_but_not_visible_in_readback': 'Payment posted but reconciliation not confirmed.',
    'status.business.write_preflight_required': 'Method-specific preflight check required before posting',
    'status.business.write_response_transaction_type_mismatch': 'Transaction type in Syrve response did not match expected.',
    'status.business.wrong_account_access_denied': 'Posting account access denied by Syrve.',
    'status.candidateWarning.manual_outlet_review_required': 'Pilih outlet secara manual',
    'status.candidateWarning.no_counterparty_match': 'Rekanan tidak cocok',
    'status.candidateWarning.outlet_ambiguous': 'Beberapa outlet',
    'status.candidateWarning.possible_duplicate': 'Kemungkinan duplikat',
    'status.duplicate.matchType.medium': 'Kemungkinan duplikat',
    'status.duplicate.matchType.strong': 'Probabilitas duplikat tinggi',
    'status.duplicate.matchType.weak': 'Perlu diperiksa',
    'status.duplicate.signal.accountNumber': 'Rekening',
    'status.duplicate.signal.amount': 'Jumlah',
    'status.duplicate.signal.bankReference': 'Referensi bank',
    'status.duplicate.signal.counterparty': 'Rekanan',
    'status.duplicate.signal.currency': 'Mata uang',
    'status.duplicate.signal.customerReference': 'Referensi pelanggan',
    'status.duplicate.signal.description': 'Deskripsi',
    'status.duplicate.signal.direction': 'Arah',
    'status.duplicate.signal.sourceBank': 'Bank',
    'status.duplicate.signal.transactionDate': 'Tanggal',
    'status.duplicate.status.candidate': 'Menunggu keputusan',
    'status.duplicate.status.confirmed': 'Duplikat terkonfirmasi',
    'status.duplicate.status.dismissed': 'Bukan duplikat',
    'status.import.accepted': 'Diterima untuk diproses',
    'status.import.failed': 'Impor gagal — periksa format file',
    'status.import.parsed': 'Terbaca — siap untuk pencocokan rekanan',
    'status.import.processing': 'Memproses file…',
    'status.manualCorrection.applied': 'Diterapkan',
    'status.manualCorrection.cancelled': 'Dibatalkan',
    'status.manualCorrection.draft': 'Draf',
    'status.manualCorrectionType.bankTransactionMetadata': 'Metadata transaksi',
    'status.manualCorrectionType.counterpartyMatch': 'Pencocokan rekanan',
    'status.manualCorrectionType.importQualityOverride': 'Override kualitas impor',
    'status.manualCorrectionType.other': 'Lainnya',
    'status.manualCorrectionType.paymentAllocationNote': 'Catatan alokasi',
    'status.match.autoMatched': 'Cocok otomatis',
    'status.match.lowConfidence': 'Keyakinan rendah',
    'status.match.manualMatched': 'Cocok manual',
    'status.match.unmatched': 'Rekanan tidak ditemukan',
    'status.match.excluded': 'Dikecualikan dari pencocokan',
    'status.matchType.candidate': 'Kandidat',
    'status.matchType.manual': 'Manual',
    'status.matchType.noMatch': 'Tidak cocok',
    'status.matchType.normalized': 'Normalisasi',
    'status.matchType.rule': 'Aturan',
    'status.quality.parseFailed': 'Kesalahan parsing',
    'status.quality.success': 'Berhasil',
    'status.syrvePayment.cancelled': 'Dibatalkan',
    'status.syrvePayment.overpaid': 'Kelebihan bayar',
    'status.syrvePayment.paid': 'Dibayar',
    'status.syrvePayment.partiallyPaid': 'Dibayar sebagian',
    'status.syrvePayment.stale': 'Tidak ditemukan pada sinkronisasi terakhir',
    'status.syrvePayment.unpaid': 'Belum dibayar',
    'status.syrvePosting.approvalRequired': 'Perlu persetujuan',
    'status.syrvePosting.approved': 'Disetujui untuk pencatatan',
    'status.syrvePosting.cancelled': 'Dibatalkan',
    'status.syrvePosting.cancelledByHardDelete': 'Dibatalkan oleh penghapusan data Pay',
    'status.syrvePosting.draft': 'Draf pencatatan',
    'status.syrvePosting.failed': 'Kesalahan',
    'status.syrvePosting.paymentWriteDisabled': 'Pencatatan pembayaran dinonaktifkan oleh pengaturan',
    'status.syrvePosting.posted': 'Dicatat, menunggu rekonsiliasi',
    'status.syrvePosting.posting': 'Sedang dicatat worker',
    'status.syrvePosting.queued': 'Dalam antrean',
    'status.syrvePosting.readbackPending': 'Menunggu pemeriksaan setelah pencatatan',
    'status.syrvePosting.writeOutcomeUnknown': 'Hasil penulisan tidak diketahui — readback diperlukan',
    'status.syrvePosting.reconciled': 'Direkonsiliasi',
    'status.syrvePosting.retryScheduled': 'Pengulangan dijadwalkan otomatis',
    'status.syrvePosting.skipped': 'Dilewati',
    'status.upload.accepted.helper': 'File diunggah dan dalam antrean. Buka impor untuk melacak progres.',
    'status.upload.accepted.label': 'File diterima',
    'status.upload.duplicate.helper': 'File ini sudah diimpor di organisasi ini. Buka impor yang ada.',
    'status.upload.duplicate.label': 'File sudah diunggah',
    'status.upload.failed.helper': 'File tidak dapat diproses. Periksa format dan coba lagi.',
    'status.upload.failed.label': 'Kesalahan impor',
    'status.upload.generic.helper': 'Buka impor untuk melihat detail.',
    'status.upload.generic.label': 'Status impor',
    'status.upload.generic.labelWithStatus': 'Status impor: {status}',
    'status.upload.parsed.helper': 'Transaksi terbaca. Periksa kualitas impor dan pencocokan rekanan.',
    'status.upload.parsed.label': 'Impor terbaca',
  },
} as const;
